import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ComponentPropsWithoutRef } from "react";

export interface PageCoverImageProps extends ComponentPropsWithoutRef<"div"> {
  alt?: string;
  thumbnail?: boolean;
  url: string;
}

export const CoverImage = ({
  url,
  alt = "",
  thumbnail = false,
  className,
  ...props
}: PageCoverImageProps) => (
  <div
    {...props}
    className={classNames(
      "bg-primary block h-auto lg:relative",
      !thumbnail &&
        "aspect-16/5 h-full max-h-[20.625rem] md:mx-auto md:max-w-5xl md:overflow-hidden md:rounded-xl",
      className,
    )}
    data-testid="cover-image-container"
  >
    <img
      loading="lazy"
      src={url}
      alt={alt}
      className={classNames("size-full", {
        "object-contain": thumbnail,
        "object-cover": !thumbnail,
      })}
      data-testid="cover-image"
    />
  </div>
);
